exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media (max-width: 375px) {\n    .card__ConsumptionEnviromentData-module___2sk09 {\n      min-width: 260px;\n    }\n  \n  }", ""]);

// Exports
exports.locals = {
	"card": "card__ConsumptionEnviromentData-module___2sk09"
};